import React, { useState } from 'react';
import Popup from './Popup'
import Popup_content from './Popup_content'

function Careere_popup() {
    const [isOpen, setIsOpen] = useState(false);
    const togglePopup = () => {
    setIsOpen(!isOpen);
  }
  return (
    <div>
      <a className="nav-link text-dark navbar_text px-3" href="#"onClick={togglePopup}>Careers {isOpen && <Popup content={<><Popup_content/></>}
        handleClose={togglePopup}/>}</a>
    </div>
  )
}

export default Careere_popup
